<template>
  <div class="matrixSinglePage">
    <div class="text" style="white-space: pre-wrap">
      {{ $filters.breakLine(translate[matrixRow.id]) }}
    </div>
    <img
      class="previewPic"
      v-if="matrixRow?.picUrl"
      :src="matrixRow?.picUrl"
      alt="previewPic"
    />
    <div class="answerWrap" :class="{ gridActive: isMatrixSingle }">
      <a
        href="javascript:void(0)"
        v-for="(answer, index) in currentAnswerConfigArray"
        :key="index"
        @click="matrixEvent(pageIndex, index)"
        :class="[
          {
            active: isMatrixSingle
              ? index === matrixAnswerArray[pageIndex]
              : index <= matrixAnswerArray[pageIndex],
          },
          isMatrixSingle ? 'choose' : 'rating',
          currentButtonType,
        ]"
      >
        <span
          v-if="currentButtonType !== 'finger'"
          style="text-align: center; white-space: pre-wrap"
          >{{ $filters.breakLine(translate[answer.id]) }}</span
        >
      </a>
    </div>
    <input
      class="input"
      :placeholder="$t('opinion')"
      v-model="commonAnswerInfo[pageIndex].edit"
      v-if="currentAnswerConfigArray[matrixAnswerArray[pageIndex]]?.allowEdit"
    />
    <div class="pagination">
      <a
        href="javascript:void(0)"
        class="prev link"
        :class="{ fade: pageIndex === 0 }"
        @click="prevMatrixPage"
        >&lt {{ $t("prev") }}</a
      >
      <span class="pageState"
        >{{ pageIndex + 1 }}/{{ matrixRowList.length }}</span
      >
      <a
        href="javascript:void(0)"
        class="next link"
        :class="{ fade: pageIndex === matrixRowList.length - 1 }"
        @click="nextMatrixPage"
        >{{ $t("next") }} &gt</a
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import answerHook from "../../hooks/answerHook";
import { computed } from "vue";
import { useStore } from "vuex";
const {
  matrixEvent,
  commonAnswerInfo,
  currentAnswerConfig,
  currentAnswerConfigArray,
  isMatrixSingle,
  currentButtonType,
  matrixAnswerArray,
  nextMatrixPage,
  prevMatrixPage,
  translate,
} = answerHook();
const store = useStore();
const matrixRowList = computed(() => currentAnswerConfig.value.rowTitleArray);
const pageIndex = computed(() => store.state.survey.currentMatrixPageIndex);
const matrixRow = computed(() => matrixRowList.value[pageIndex.value]);
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.matrixSinglePage {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #333;
  .text {
    color: #333;
    font-size: 26px;
    margin-bottom: 10px;
    align-self: flex-start;
    padding-left: 2%;
    @media screen and (orientation: landscape) {
      font-size: 26px;
      margin-bottom: 10px;
    }
  }
  .answerWrap {
    display: flex;
    width: 96%;
    justify-content: space-between;
    margin: 30px 0;
    @media (orientation: landscape) {
      margin: 30px 0;
    }
    &.gridActive {
      display: grid;
      justify-items: center;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 20px;
      @media (orientation: landscape) {
        grid-column-gap: 20px;
      }
    }
    .choose {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 70px;
      margin: 10px 20px;
      color: #333;
      font-size: 20px;
      background: #f8f8f8;
      border-radius: 15px;
      border: 1px solid $btnColor;
      box-sizing: border-box;
      @media (orientation: landscape) {
        height: 70px;
        margin: 10px 20px;
        font-size: 20px;
        border-radius: 15px;
        border: 1px solid $btnColor;
      }
      &.active {
        background: $btnColor;
        border: none;
        color: #fff;
      }
    }
  }
  .input {
    font-size: 14px;
    height: 60px;
    padding-left: 30px;
    box-sizing: border-box;
    margin: 20px 0;
    background: #f7f7f7;
    width: 96%;
    border-radius: 8px;
    @media screen and (orientation: landscape) {
      font-size: 14px;
      height: 60px;
      padding-left: 30px;
      margin: 20px 0;
      border-radius: 8px;
    }
  }
  .pagination {
    display: flex;
    width: 96%;
    height: 70px;
    margin-top: 10px;
    align-items: center;
    justify-content: space-around;
    position: relative;
    @media screen and (orientation: landscape) {
      height: 70px;
      margin-top: 10px;
    }
    .link {
      color: #000;
      height: 100%;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (orientation: landscape) {
        font-size: 20px;
      }
      &.fade {
        cursor: unset;
        color: #999;
      }
    }
    .pageState {
      display: flex;
      width: 80px;
      height: 40px;
      color: #999;
      font-size: 16px;
      align-items: center;
      justify-content: center;
      border-radius: 15px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      @media screen and (orientation: landscape) {
        width: 80px;
        height: 40px;
        font-size: 16px;
        border-radius: 15px;
      }
    }
  }
}
</style>
